import React from "react";
import ReactDOM from "react-dom";

import Button from "../../../common/components/Button";
import Context from "../../../context/Context";
import DateTime from "./DateTime";
import Duration from "./Duration";
import EsriReservationSchema from "../More/Actions/BookWorkspace/WorkspaceReservation/EsriReservationSchema";
import FieldNames from "../../../aiim/datasets/FieldNames";
import ItemReference from "../../../aiim/base/ItemReference";
import Loader from "calcite-react/Loader/Loader";
import ModalController from "../../../common/components/Modal/ModalController";
import Schedule from "./Schedule";
import TextField from "calcite-react/TextField";
import * as aiimUtil from "../../../aiim/util/aiimUtil";
import * as component from "../../util/component";
import * as dateUtil from "../Events/dateUtil";
import * as ics from "../Events/ics";
import MeetingBookingConfirmed from "./MeetingBookingConfirmed";
import BookingConfirmed from "../More/Actions/BookWorkspace/BookingConfirmed";
import { makeEventInfo } from "../../../util/calendarUtil";
import { isNetworkError } from "../../../util/networkUtil";
import { getMeetingBookingSystem, getMeetingBookingSystemType } from "../More/Actions/BookWorkspace/WorkspaceReservation/workspaceReservationUtil";
import * as validateUtil from "../More/Actions/BookWorkspace/validateUtil";
import Topic from '../../../context/Topic';
import TextareaAutosize from 'react-textarea-autosize';

export default class Book extends React.Component {

  componentId;
  durationComponent;
  startComponent;
  endComponent;
  isOngoingBooking = false;
  maxLenO365Desc = 4000;

  constructor(props) {
    super(props);
    this.componentId = component.nextId("book-");
    let title = null;
    if(this.props.criteria && this.props.criteria.operation === "updateBookingTime") {
      title = this.props && this.props.item && this.props.item.title; 
    }
    this.state = component.newState({
      title: title || "",
      titleError: null,
      description: null,
      descriptionCharCount: 0,
      working: false
    });
  }

  componentDidMount() {
    this.props.onMount && this.props.onMount(this);
    setTimeout(() => this._checkModalOKButton(), 300);
  }

  componentWillUnmount() {
    component.componentWillUnmount(this);
  }

  getDescriptionFieldLength=()=>{
    const bookingSystemType = getMeetingBookingSystemType();
    if (bookingSystemType === "office365") {
      return this.maxLenO365Desc;
    } else {
      const reservation = Context.instance.aiim.datasets.reservations;
      const fields = reservation && reservation.layer2D && reservation.layer2D.fields;
      if (!fields) return 0;
      const field = aiimUtil.findField(fields,FieldNames.DESCRIPTION);
      return field.length;
    }
  }

  _checkModalOKButton() {
    const i18n = Context.instance.i18n;

    if (!this.modalOkButton)
      return true;
    let btnNode = ReactDOM.findDOMNode(this.modalOkButton);
    if (btnNode) {
      btnNode.title = "";
      btnNode.style.setProperty("pointer-events", "auto");
    }
    const origWhen = Book.getOrigWhen(this.props.originalReservation);    
    if (!origWhen)
      return true;

    let newCriteria = {};
    let btnTitle;
    let ok = this.validate(newCriteria);
    if (ok) {
      ok = newCriteria.when.end.date > Date.now();
      btnTitle = !ok ? i18n.meetingRooms.book.invalidEndDate : btnTitle;
    }

    if (ok) {
      ok = !(newCriteria.when.start.date===origWhen.start && newCriteria.when.end.date===origWhen.end && newCriteria.title===origWhen.title);
      btnTitle = !ok ? `${i18n.meetingRooms.book.noChangesMsg}` : btnTitle;
    }

    if (ok) {
      this.modalOkButton.enable();
      btnNode && (btnNode.title = "");
    } else {
      this.modalOkButton.disable()
      btnNode && (btnNode.title = btnTitle);
    }
    
    return ok;
  }

  render() {
    const i18n = Context.instance.i18n;
    const when = Object.assign({},this.props.criteria.when);
    let disabled = false;
    let isOngoingBooking = false;
    const placeholder = i18n.meetingRooms.book.title;

    const unitFeature = this.props && this.props.item && this.props.item.feature;
    let equipmentStr = null;
    const equipmentList = Context.instance.aiim.datasets.units.getEquipmentList(unitFeature, "DOM_EQUIPMENT_MEETING");
    if (equipmentList && equipmentList.length > 0 ) equipmentStr = equipmentList.join(', ');

    const onPartChanged = (c,type,dateMoment,timeMoment,prev) => {
      let c2 = this.endComponent;
      if (c === this.endComponent) c2 = this.startComponent;
      c2.whenAssociatedPartChanged(c,type,dateMoment,timeMoment,this.durationComponent,prev);
      setTimeout(() => this._checkModalOKButton(), 300);
    };

    const onDurationChanged = (val, oldVal) => {
      setTimeout(() => this._checkModalOKButton(), 300);
    }

    let loader;
    if (this.state.working) {
      loader = (
        <div style={{position:"absolute",width:"80%",top:"100px"}}>
          <Loader sizeRatio={1} style={{marginTop: "3rem"}} />
        </div>
      );
    }

    const maxLen = this.getDescriptionFieldLength();

    let pattern = i18n.item.categoryTypePattern;
    pattern = pattern.replace("{category}", this.state.descriptionCharCount);
    pattern = pattern.replace("{type}", maxLen);

    let showDesc = true;
    if(this.props.criteria && this.props.criteria.operation === "updateBookingTime") showDesc = false;

    if(this.props.criteria && this.props.criteria.operation === "updateBookingTime") {
      if(this.props.criteria.isOngoingBooking) {
        disabled = true;
        isOngoingBooking = true;
      }
    }

    return (
      <div className="i-filter-form">
        <div style={{marginBottom: "1.2rem"}}>
          <TextField type="text"
            placeholder={placeholder}
            error={!!this.state.titleError}
            title={this.state.titleError}
            value={this.state.title}
            onChange={evt => {
              let v = evt.target.value;
              this.setState({
                title: v,
                titleError: null
              }, () => setTimeout(() => this._checkModalOKButton(), 300));
            }}
          />
        </div>
        {showDesc && <div style={{marginBottom: "1.2rem"}}>
          <TextareaAutosize 
            placeholder={i18n.meetingRooms.book.descriptionMeeting}
            maxLength={maxLen}
            maxRows = {4}
            value={this.state.description}
            onChange={evt => {
              let v = evt.target.value;
              this.setState({
                description: v,
                descriptionCharCount: v.length
              }, () => {
                if (v.length >= maxLen) {
                  Topic.publish(Topic.ShowToast, { message: i18n.meetingRooms.book.descriptionLimitToast })
                }
              });
            }}
            minRows={3}/>
            <div style={{fontSize: "0.8125rem"}}>{pattern}</div>
        </div>}
        {loader}
        <div>
          <Duration
            isOngoingBooking={isOngoingBooking}
            disabled={disabled}
            formKey={this.componentId}
            duration={when.duration}
            criteria={when}
            onChange={onDurationChanged}
            onMount={c => this.durationComponent = c}/>
        </div>
        <div>
          <DateTime
            formKey={this.componentId}
            isOngoingBooking={isOngoingBooking}
            disabled={disabled}
            duration={when.duration}
            criteria={when}
            label={i18n.meetingRooms.start}
            isStart={true}
            date={when.start.date}
            onMount={c => this.startComponent = c}
            onPartChanged={onPartChanged} />
        </div>
        <div>
          <DateTime
            formKey={this.componentId}
            duration={when.duration}
            criteria={when}
            label={i18n.meetingRooms.end}
            isEnd={true}
            date={when.end.date}
            startDate={when.start.date}
            onMount={c => this.endComponent = c}
            onPartChanged={onPartChanged} />
        </div>
        <div>
          <div>{i18n.meetingRooms.book.location}</div>
          <div
            style={{
              marginTop: "0.3rem"
            }}>
            {this.props.item.name}
          </div>
        </div>
        {equipmentStr && (
          <div style={{marginTop: "1.2rem", maxWidth: "80vh", width: "348px"}}>
            <div>{i18n.more.bookWorkspace.equipmentType}</div>
            <div 
              style={{
                marginTop: "0.3rem"
            }}>
              {equipmentStr}
            </div>
          </div>
        )}
        {/*
        <div style={{marginTop: "1.2rem"}}>
          <div>{i18n.meetingRooms.book.description}</div>
          <div>
            <TextField type="textarea"
              onChange={evt => {
                let v = evt.target.value;
                this.setState({
                  description: v
                });
              }}
            />
          </div>
        </div>
        */}
      </div>
    );
  }

  setStart(m,roundedMillis) {
    this.startComponent.setFromMoment(m,roundedMillis);
  }

  setWhen(when) {
    this.durationComponent.setWhen(when.duration);
    this.startComponent.setWhen(when.start.date,when.duration);
    this.endComponent.setWhen(when.end.date,when.duration);
    setTimeout(() => this._checkModalOKButton(), 300);
  }

  validate(criteria,whenOnly) {
    const i18n = Context.instance.i18n;
    let ok = true;
    let when = {
      duration: null,
      start: {},
      end: {}
    };

    let title = this.state.title;
    if (typeof title !== "string") title = "";
    title = title.trim();
    if (title.length === 0 && !whenOnly) {
      ok = false;
      this.setState({
        titleError: i18n.general.valueRequired
      })
    }

    let desc = this.state.description;
    if (typeof desc === "string") desc = desc.trim();

    if (ok) ok = this.durationComponent.validate(when);
    if (ok) ok = this.startComponent.validate(when.start);
    if (ok) ok = this.endComponent.validate(when.end);
    if (ok) {
      if (when.start.date && when.end.date &&
         (when.start.date <= when.end.date)) {
        // also check isRequired?
      }
    }
    if (ok && when.start.date && when.end.date && when.duration) {
      if (when.duration === "allDay") {
        let dt1 = dateUtil.toStartOfDay(new Date(when.start.date));
        let dt2 = dateUtil.toEndOfDay(new Date(when.end.date));
        //let d = dateUtil.getDurationKey(dt1,dt2);
        when.start.date = dt1.getTime();
        when.end.date = dt2.getTime();
        //when.duration = d;
      } else {
        let dt1 = new Date(when.start.date);
        let dt2 = new Date(when.end.date);
        let d = dateUtil.getDurationKey(dt1,dt2);
        when.duration = d;
      }
    }
    if (ok) {
      criteria.title = title;
      criteria.description = desc;
      criteria.when = when;
    }
    return ok;
  }

  static createBookingEsri (task) {
    task.bookComponent.setState({working: true});
    const i18n = Context.instance.i18n;

    let itemRef;
    const ds = Context.instance.aiim.datasets.units;
    const source = ds && ds.getSource();
    const sr = source && source.makeSearchResult(null,task.item.feature);
    if (sr) {
      itemRef = new ItemReference();
      itemRef.fromSearchResult(source.key,sr)
    }

    const when = task.criteria.when;
    const params = {
      title: task.criteria.title,
      description: Context.sanitizeHtml(task.criteria.description),
      noAutoDescription: true,
      unit: task.item.feature,
      checkIn: when.start.date,
      checkOut: when.end.date,
      allDay: (when.duration === "allDay"),
      item: itemRef,
      bookingType: "meetingRooms"
    };
    if (params.allDay) {
      params.checkIn = dateUtil.toStartOfDay(new Date(params.checkIn)).getTime();
      params.checkOut = dateUtil.toEndOfDay(new Date(params.checkOut)).getTime();
    }

    let r = Context.instance.aiim.datasets.reservations;
    let unitId = task.item.unitId;
    let fromDate = new Date(params.checkIn);
    let toDate = new Date(params.checkOut);

    let sys = EsriReservationSchema.getInstance();

    r.queryUnitSchedule(unitId,fromDate,toDate,true).then(result => {
      //console.log("queryUnitSchedule.result",result)
      task.available = false;
      if (result && result.reserved && result.reserved.length === 0) {
        task.available = true;
      }
      if (task.available) {
        return sys.bookWorkspace( params);
      } else {
        let err = new Error("Not available.");
        err.code = "__notAvailable__";
        throw err;
      }

    }).then(result => {
      const reservation = result.reservations && result.reservations.length > 0 && result.reservations[0];
      task.reservation = reservation;
      return Book.makeIcsInfo(task, reservation);
    }).then(() => {
      const reservationsDataset = Context.getInstance().aiim.datasets.reservations;
      const unitsDataset = Context.getInstance().aiim.datasets.units;
      const calendarParams = makeEventInfo(reservationsDataset, task.reservation, unitsDataset, task.item.feature, "addBooking");
      const lib = Context.instance.lib
      const levels = Context.instance.aiim.datasets.levels;
      let attr = task.reservation.attributes;
      let name = aiimUtil.getAttributeValue(attr,FieldNames.TITLE);
      let dtFrom = new Date(aiimUtil.getAttributeValue(attr,FieldNames.START_TIME));
      let dtTo = new Date(aiimUtil.getAttributeValue(attr,FieldNames.END_TIME));
      let fullName = aiimUtil.getAttributeValue(attr,FieldNames.RESERVED_FOR_FULL_NAME);
      let levelId = aiimUtil.getAttributeValue(attr,FieldNames.LEVEL_ID);
      let unit = aiimUtil.getAttributeValue(attr,FieldNames.UNIT_NAME);
      let from = lib.dojo.locale.format(dtFrom,{formatLength:"short"});
      let to = lib.dojo.locale.format(dtTo,{formatLength:"short"});
      let range = i18n.meetingRooms.rangePattern.replace("{fromDate}",from).replace("{toDate}",to);
      let orgBy = i18n.meetingRooms.organizedBy.replace("{person}",fullName);
      let fl;
      let ld = levels && levels.getLevelData(levelId);
      if (ld) {
        let p = i18n.meetingRooms.levelAndFacility;
        fl = p.replace("{levelName}",ld.levelName).replace("{facilityName}",ld.facilityName);
      }
      // let icsNode, icsInfo = task.icsInfo;
      // if (icsInfo && typeof icsInfo.href === "string") {
      //   icsNode = <IcsLink icsInfo={icsInfo} />
      // }
      // const addToCalendarButton = (
      //   <button
      //     className={"i-button"}
      //   >
      //     {i18n.events.details.addToCalendar}
      //   </button>
      // );


      let content = (
        <MeetingBookingConfirmed
          name={name}
          range={range}
          unit={unit}
          fl={fl}
          orgBy={orgBy}
          calendarParams={calendarParams}
        />
      );

      task.controller.close();
      const c = new ModalController();
      c.show({
        title: i18n.meetingRooms.book.newMeeting,
        className: "i-modal-confirm i-modal-transparent",
        showOKCancel: false
      },content);

    }).catch(ex => {
      console.error(ex);
      task.status.executing = false;
      task.bookComponent.setState({working: false});

      const errorDetails = ex && ex.details;
      let msg = errorDetails && errorDetails.messages && errorDetails.messages.length
        ? errorDetails.messages.join("/n")
        : ex && ex.message
          ? ex.message
          : "";
      let msgTitle = i18n.meetingRooms.book.couldNotBookTitle;
      if (ex && ex.code === "__notAvailable__") {
        msgTitle = i18n.meetingRooms.book.roomUnavailableTitle;
        msg = i18n.meetingRooms.book.roomUnavailable;
        msg = msg.replace("{unitName}",task.item.name);
      } else if (ex && isNetworkError(ex.message)) {
        msg = i18n.meetingRooms.issues.m1;
      }

      if (ex && ex.code === "booking-lock-conflict") {
        msgTitle = i18n.more.bookWorkspace.bookingConflict;
        msg = i18n.meetingRooms.book.couldNotBookMsg;
      }

      ModalController.confirm({
        isError: true,
        title: msgTitle,
        message: msg,
        submessage: null,
        hideCancel: true
      });

    })
  }

  static async createBookingOffice365 (task) {
    task.bookComponent.setState({working: true});
    let itemRef;
    const ds = Context.instance.aiim.datasets.units;
    const source = ds && ds.getSource();
    const sr = source && source.makeSearchResult(null,task.item.feature);
    if (sr) {
      itemRef = new ItemReference();
      itemRef.fromSearchResult(source.key,sr)
    }
    const when = task.criteria.when;
    const bookingSystem = getMeetingBookingSystem();
    const item = task && task.item;
    const params = {
      title: task.criteria.title,
      description: Context.sanitizeHtml(task.criteria.description),
      checkInDate: new Date(when.start.date),
      checkOutDate: new Date(when.end.date),
      allDay: (when.duration === "allDay"),
      unit: item.feature,
      item: itemRef,
      unitName: item.name,
      scheduleEmail: item.scheduleEmail,
      bookingSystem: bookingSystem,
      bookingType: "meetingRooms",
      controller: task.controller,
      renderBookingConfirmed: this.renderBookingConfirmed365
    }
    const response = await validateUtil.verifyAndBook(params);
    if (!response || (response && ((response.warnings && response.warnings.length > 0) || response.error))) {
      task.status.executing = false;
      task.bookComponent.setState({working: false});
    }
    return response;
  }

  static async updateBookingOffice365(task) {
    task.bookComponent.setState({working: true});
    let itemRef;
    const ds = Context.instance.aiim.datasets.units;
    const source = ds && ds.getSource();
    const sr = source && source.makeSearchResult(null,task.item.feature);
    if (sr) {
      itemRef = new ItemReference();
      itemRef.fromSearchResult(source.key,sr)
    }
    const when = task.criteria.when;
    const bookingSystem = getMeetingBookingSystem();
    const item = task && task.item;
    const params = {
      title: task.criteria.title,
      checkInDate: new Date(when.start.date),
      checkOutDate: new Date(when.end.date),
      allDay: (when.duration === "allDay"),
      unit: item.feature,
      item: itemRef,
      unitName: item.name,
      scheduleEmail: item.scheduleEmail,
      bookingSystem: bookingSystem,
      bookingType: "meetingRooms",
      controller: task.controller,
      operation: "updateBookingTime",
      eventId: task.criteria.eventId,
      client: task.criteria.client,
      origBooking: task && task.item && task.item.origBooking,
      renderBookingConfirmed: this.renderBookingConfirmed365
    }
    const response = await validateUtil.verifyAndBook(params);
    if (!response || (response && response.warnings && response.warnings.length > 0)) {
      task.status.executing = false;
      task.bookComponent.setState({working: false});
    }
    return response;
  }

  static async updateBookingEsri(task) {
    task.bookComponent.setState({working: true});
    let itemRef;
    const ds = Context.instance.aiim.datasets.units;
    const source = ds && ds.getSource();
    const sr = source && source.makeSearchResult(null,task.item.feature);
    if (sr) {
      itemRef = new ItemReference();
      itemRef.fromSearchResult(source.key,sr)
    }

    const origResAttr = task && task.originalReservation && task.originalReservation.attributes; 
    const when = task.criteria.when;
    const bookingSystem = getMeetingBookingSystem();
    const item = task && task.item;
    const params = {
      title: task.criteria.title,
      description: aiimUtil.getAttributeValue(origResAttr, FieldNames.DESCRIPTION),
      checkInDate: new Date(when.start.date),
      checkOutDate: new Date(when.end.date),
      allDay: (when.duration === "allDay"),
      unit: item.feature,
      item: itemRef,
      unitName: item.name,
      bookingSystem: bookingSystem,
      bookingType: "meetingRooms",
      controller: task.controller,
      operation: "updateBookingTime",
      objectIds: task && task.criteria && [task.criteria.objectID]
    }
    
    const response = await validateUtil.verifyAndBook(params);
    if (!response || (response && response.error) || (response && response.warnings && response.warnings.length > 0)) {
      task.status.executing = false;
      task.bookComponent.setState({working: false});
      return response;
    }
    
    Topic.publish(Topic.RenderMeetingRooms, {origResAttr: origResAttr});
    if (response && response.reservation) 
      task.reservation = response.reservation;
    await Book.makeIcsInfo(task, task.reservation);
    const reservationsDataset = Context.getInstance().aiim.datasets.reservations;
    const unitsDataset = Context.getInstance().aiim.datasets.units;
    const calendarParams = makeEventInfo(reservationsDataset, task.reservation, unitsDataset, task.item.feature, "updateBooking");
    const lib = Context.instance.lib
    const levels = Context.instance.aiim.datasets.levels;
    let attr = task.reservation.attributes;
    let name = aiimUtil.getAttributeValue(attr,FieldNames.TITLE);
    let dtFrom = new Date(aiimUtil.getAttributeValue(attr,FieldNames.START_TIME));
    let dtTo = new Date(aiimUtil.getAttributeValue(attr,FieldNames.END_TIME));
    let fullName = aiimUtil.getAttributeValue(attr,FieldNames.RESERVED_FOR_FULL_NAME);
    let levelId = aiimUtil.getAttributeValue(attr,FieldNames.LEVEL_ID);
    let unit = aiimUtil.getAttributeValue(attr,FieldNames.UNIT_NAME);
    let from = lib.dojo.locale.format(dtFrom,{formatLength:"short"});
    let to = lib.dojo.locale.format(dtTo,{formatLength:"short"});
    const i18n = Context.instance.i18n;
    let range = i18n.meetingRooms.rangePattern.replace("{fromDate}",from).replace("{toDate}",to);
    let orgBy = i18n.meetingRooms.organizedBy.replace("{person}",fullName);
    let fl;
    let ld = levels && levels.getLevelData(levelId);
    if (ld) {
      let p = i18n.meetingRooms.levelAndFacility;
      fl = p.replace("{levelName}",ld.levelName).replace("{facilityName}",ld.facilityName);
    }

    let content = (
      <MeetingBookingConfirmed
        name={name}
        range={range}
        unit={unit}
        fl={fl}
        orgBy={orgBy}
        calendarParams={calendarParams}
        updateBooking={true}
        origResAttr={origResAttr}
      />
    );
    task.controller.close();
    const c = new ModalController();

    c.show({
      title: i18n.meetingRooms.book.updateMeeting,
      className: "i-modal-confirm i-modal-transparent",
      showOKCancel: false
    },content);
  }

  static getOrigWhen(originalReservation) {
    if (!originalReservation)
      return null;
    const origResAttr = originalReservation.attributes;
    const origBooking = originalReservation.booking;      
    if (!origResAttr && !origBooking)
      return null;

    let start, end, allDay, title;
    if (origResAttr) {
      start = aiimUtil.getAttributeValue(origResAttr, FieldNames.START_TIME);
      end = aiimUtil.getAttributeValue(origResAttr, FieldNames.END_TIME);
      allDay = aiimUtil.getAttributeValue(origResAttr, FieldNames.ALL_DAY) ? true : false;
      title = aiimUtil.getAttributeValue(origResAttr, FieldNames.TITLE);
    } else if (origBooking) {
      const o365toDateObj = dateUtil.O365toDate(origBooking.start.dateTime, origBooking.end.dateTime);
      start = dateUtil.getMsFromTimeObj(o365toDateObj.fromDateTime);
      end = dateUtil.getMsFromTimeObj(o365toDateObj.toDateTime);
      allDay = origBooking.isAllDay;
      title = origBooking.subject;
    }
    if (start && end)
      return {start, end, title, allDay, duration:allDay, isAllDay:allDay};
    return null; 
  }

  static async createBooking (task) {
    const bookingSystemType = getMeetingBookingSystemType();
    if (bookingSystemType === "office365") {
      await Book.createBookingOffice365(task);
    } else {
      Book.createBookingEsri(task);
    }
  }

  static async updateBooking(task) {
    const bookingSystemType = getMeetingBookingSystemType();
    if (bookingSystemType === "office365") {
      await Book.updateBookingOffice365(task);
    } else if (bookingSystemType === "esri") {
      await Book.updateBookingEsri(task);
    }
  }

  static renderBookingConfirmed365(data, params, task) {
    task.controller.close();
    const node = document.createElement("div");
    document.body.appendChild(node);

    const unit = task && task.unit;
    const attributes = unit && unit.attributes;
    const levelId = aiimUtil.getAttributeValue(attributes, FieldNames.LEVEL_ID);
    const levels = Context.getInstance().aiim.datasets.levels;
    const levelData = levels.getLevelData(levelId); 
    const levelName = levelData && levelData.levelName;
    const facilityName = levelData && levelData.facilityName;

    const onClose = () => {
      if (node && node.parentNode) {
        node.parentNode.removeChild(node);
        ReactDOM.unmountComponentAtNode(node)
      }
    };

    ReactDOM.render((
      <BookingConfirmed
        bookingSystemType={getMeetingBookingSystemType()}
        unitName={task.unitName}
        levelName={levelName}
        facilityName={facilityName}
        closePopup={onClose}
        data={data}
        unit={params && params.unit}
        params={params}
      />
    ), node);
  }


  static makeIcsInfo(task,reservation) {
    const promise = new Promise((resolve,reject) => {
      let feature = task.item.feature;
      let filename = "reservation.ics";
      let attr = reservation.attributes;
      let info = {
        name: aiimUtil.getAttributeValue(attr,FieldNames.TITLE),
        description: aiimUtil.getAttributeValue(attr,FieldNames.DESCRIPTION),
        location: aiimUtil.getAttributeValue(attr,FieldNames.UNIT_NAME),
        date_start: new Date(aiimUtil.getAttributeValue(attr,FieldNames.START_TIME)),
        date_end: new Date(aiimUtil.getAttributeValue(attr,FieldNames.END_TIME)),
        geo: null,
        geometry: feature && feature.geometry
      };
      ics.makeIcsInfo(info,filename).then(icsInfo => {
        task.icsInfo = icsInfo;
        resolve();
      }).catch(ex => {
        console.error("Error generating .ics file:",ex);
        resolve();
      });
    });
    return promise;
  }

  static scheduleClicked(task) {
    const i18n = Context.instance.i18n;
    const roomItem = {
      unitId: task.item.unitId,
      name: task.item.name,
      unitFeature: task.item.feature
    };
    const when = task.criteria.when;
    const start = when.start.date;
    const targetWhen = {
      duration: when.duration,
      start: {
        date: when.start.date
      },
      end: {
        date: when.end.date
      },
    }

    const controller = new ModalController();
    let title = i18n.meetingRooms.schedule.captionPattern;
    title = title.replace("{room}",roomItem.name);
    const modalProps = {
      className: "i-modal-confirm i-modal-schedule",
      title: title,
      cancelLabel: i18n.general.close,
      showOKCancel: true,
      hideOK: true
    };

    const content = (
      <Schedule 
        bookingType="meetingRooms"
        operation={task.criteria.operation}
        isOngoingBooking={task.criteria.isOngoingBooking}
        item={roomItem} 
        start={start} 
        when={targetWhen}
        originalReservation={task.originalReservation}
        onBookClicked={selectedWhen => {
          task.bookComponent.setWhen(selectedWhen);
          controller.close();
        }}
      />
    )
    controller.show(modalProps,content);
  }

  static show(info) {    
    const item = info.bookItem;
    const criteria = info.criteria;
    const operation = criteria && criteria.operation;
    const originalReservation = info && info.originalReservation;

    const is365 = getMeetingBookingSystemType() === "office365";
    if (item && is365 && !item.scheduleEmail && item.feature && item.feature.attributes) {
      item.scheduleEmail = aiimUtil.getAttributeValue(item.feature.attributes, FieldNames.SCHEDULE_EMAIL);
    }

    let bookComponent;
    let okButton;
    const status = {executing: false}
    const i18n = Context.instance.i18n;
    const controller = new ModalController();
    let title = i18n.meetingRooms.book.newMeeting;
    if (operation && operation === "updateBookingTime") title = i18n.meetingRooms.book.updateMeeting;
    const modalProps = {
      className: "i-modal-confirm",
      title: title,
      okLabel: i18n.more.bookWorkspace.confirm,
      showOKCancel: true,
      hideCancel: true,
      closeOnOK: false,
      onMountOKButton: btn => {
        okButton = btn;
        if (bookComponent)
          bookComponent.modalOkButton = btn;
        //if (trackChange) okButton.disable()
      },      
      onOK: () => {
        if (status.executing) return;
        let newCriteria = {};
        let ok = bookComponent.validate(newCriteria);
        if (ok) {
          if (newCriteria.when.end.date <= Date.now()) {
            ok = false;
            ModalController.showMessage(i18n.more.bookWorkspace.pastTime, title);
          }
        }

        const origWhen = Book.getOrigWhen(originalReservation);
        if (ok && origWhen) {
          const when = newCriteria.when;
          //(when.duration==="allDay" && origWhen.duration==="allDay") //oneHour,allDay etc. 
          if (when.start.date===origWhen.start.date && when.end.date===origWhen.end.date && newCriteria.title===item.title) {
            ok = false; 
            ModalController.showMessage(i18n.meetingRooms.book.noChangesMsg);
          }
        }

        if (ok) {
          status.executing = true;
          if (operation === "updateBookingTime") {
            if(newCriteria) {
              newCriteria.eventId = criteria.eventId
              newCriteria.client = criteria.client
              newCriteria.operation = operation
              newCriteria.objectID = criteria && criteria.objectID;
            }
            Book.updateBooking({
              item: item,
              criteria: newCriteria,
              bookComponent: bookComponent,
              controller: controller,
              status: status,
              originalReservation,
            })
          } else {
            Book.createBooking({
              item: item,
              criteria: newCriteria,
              bookComponent: bookComponent,
              controller: controller,
              status: status
            });
          }
        }
      },
      extraButton: (
        <Button key="extraButton" className="i-extra-button"
          onClick={() => {
            let newCriteria = {};
            bookComponent.validate(newCriteria,true);
            if (operation === "updateBookingTime") {
              newCriteria.eventId = criteria.eventId
              newCriteria.client = criteria.client
              newCriteria.operation = operation
              newCriteria.isOngoingBooking = criteria.isOngoingBooking
            }
            Book.scheduleClicked({
              item: item,
              criteria: newCriteria,
              bookComponent: bookComponent,
              controller: controller,
              status: status,
              originalReservation,
            });
          }}
        >{i18n.meetingRooms.schedule.viewSchedule}</Button>
      )
    };
    const content = (
      <Book 
        item={item} 
        criteria={criteria}
        onMount={c => bookComponent = c }
        originalReservation={originalReservation}
      />
    )
    controller.show(modalProps,content);
  }
}
